import dynamic from "next/dynamic"

import { useAddCartLines } from "@unlikelystudio/react-ecommerce-hooks"

import { useEmitCustomAnalyticsEvent } from "~/hooks/tracking/useEmitCustomAnalyticsEvent"
import { useAlerts } from "~/hooks/useAlerts"
import type { AddtoCartCtaProps } from "~/components/ui/AddToCartCta"
import { usePanel } from "~/managers/PanelManager"

const CartPanel = dynamic(() => import("~/components/ui/CartPanel"))

export function useAddToCart(
  variants: AddtoCartCtaProps["activeVariants"],
  onSuccess?: NonNullable<Parameters<typeof useAddCartLines>[0]>["onSuccess"],
  openPanel: boolean = true,
  fromKleep: boolean = false
) {
  const { add } = usePanel()
  const triggerAlert = useAlerts()
  const { emitCustomEvent } = useEmitCustomAnalyticsEvent()

  const { mutate, isLoading } = useAddCartLines({
    onSuccess: (data, ...params) => {
      onSuccess?.(data, ...params)
      if (data.cart) {
        emitCustomEvent<"add_to_cart">("add_to_cart", { cartPayload: data.cart, fromKleep, variants })
      }
      openPanel && add(<CartPanel />)
    },
    onError: () => {
      triggerAlert()
    },
  })

  return { mutate, isLoading }
}
